import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CasesModule } from '../cases/cases.module';
import { CaseDrawerComponent } from './components/case-drawer/case-drawer.component';
import { InformationDrawerComponent } from './components/information-drawer/information-drawer.component';
import { JoinGroupComponent } from './components/join-group/join-group.component';
import { NotificationCardComponent } from './components/notification-card/notification-card.component';
import { MainComponent } from './pages/main/main.component';

@NgModule({
  declarations: [
    MainComponent,
    InformationDrawerComponent,
    JoinGroupComponent,
    NotificationCardComponent,
    CaseDrawerComponent,
  ],
  imports: [AppRoutingModule, SharedModule, CasesModule],
  exports: [MainComponent],
})
export class MainModule {}
